import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'rtmEventSignalValues',
  initialState: {},
  reducers: {
    setSignalValues: (state, { payload }) => {
      state[`${payload.eventId}-${payload.signalId}`] = {
        data: payload.data,
        vTable: payload.vTable,
      }
    },
  },
})

export const { setSignalValues } = slice.actions

export default slice.reducer

export const selectSignalValues = (eventId, signalId) => (state) =>
  state.rtmEventSignalValues[`${eventId}-${signalId}`]?.data

export const selectSignalVTable = (eventId, signalId) => (state) =>
  state.rtmEventSignalValues[`${eventId}-${signalId}`]?.vTable
